module.exports = __webpack_public_path__ + "img/2@2x.f432f709.png";